export default __webpack_public_path__ + "static/media/wallet.b86dd280.svg";